import PropTypes from "prop-types";
import { useEffect } from "react";
import ReactGA from "react-ga4";

import archidekt from "assets/ads/archidekt.png";
import bcw from "assets/ads/bcw.jpg";
import cc from "assets/ads/cc.png";
import ch from "assets/ads/ch.png";
import commandzone from "assets/ads/commandzone.jpg";
import csb from "assets/ads/csb.png";
import fabrec from "assets/ads/fabrec.png";
import heavyPlay320 from "assets/ads/heavyPlay320.png";
import heavyPlay728 from "assets/ads/heavyPlay728.png";
import OutboundLink from "components/OutboundLink";

import styles from "./Ad.module.scss";

const config = {
  archidekt: { alt: "Archidekt", src: archidekt, url: "archidekt.com" },
  bcw: {
    alt: "BCW Supplies",
    src: bcw,
    url: "www.bcwsupplies.com/?acc=edhrec",
  },
  cc: { alt: "Commander Codex", src: cc, url: "commandercodex.com" },
  ch: { alt: "Commander's Herald", src: ch, url: "commandersherald.com" },
  commandzone: { alt: "The Command Zone", src: commandzone, url: "www.youtube.com/@commandcast/videos" },
  csb: { alt: "Commander Spellbook", src: csb, url: "commanderspellbook.com" },
  fabrec: { alt: "FABREC", src: fabrec, url: "fabrec.gg" },
  heavyPlay: {
    alt: "Heavy Play",
    src: { lg: heavyPlay728, sm: heavyPlay320 },
    url: {
      lg: "https://heavyplay.com/discount/edhrec?redirect=/collections/rng-max-deckbox",
      sm: "https://heavyplay.com/discount/edhrec?redirect=/collections/rng-max-deckbox",
    },
  },
};

const Ad = ({ id }) => {
  useEffect(() => {
    ReactGA.event({
      action: "Load",
      category: "Ad",
      label: id,
      nonInteraction: true,
    });
  }, [id]);

  if (!Object.keys(config).includes(id)) {
    return null;
  }

  const { alt, src, url } = config[id];

  if (typeof url === "string") {
    return (
      <OutboundLink url={url} utm_medium="leaderboard">
        <img alt={alt} className={styles.ad} src={src} />
      </OutboundLink>
    );
  } else {
    return (
      <>
        <OutboundLink className="d-block d-sm-none" url={url.sm} utm_medium="leaderboard">
          <img alt={alt} className={styles.ad} src={src.sm} />
        </OutboundLink>
        <OutboundLink className="d-none d-sm-block" url={url.lg} utm_medium="leaderboard">
          <img alt={alt} className={styles.ad} src={src.lg} />
        </OutboundLink>
      </>
    );
  }
};

Ad.propTypes = {
  id: PropTypes.string.isRequired,
};

export default Ad;
